import * as React from 'react';
import FilmSearch from '../components/search/FilmSearch';
import SerialSearch from '../components/search/SerialSearch';
import ClipSearch from '../components/search/ClipSearch';
import AlbumSearch from '../components/search/AlbumSearch';
import TrackSearch from '../components/search/TrackSearch';
import ConcertSearch from '../components/search/ConcertSearch';
import ShowBusinessSearch from '../components/search/ShowBusinessSearch';
import WallpaperSearch from '../components/search/WallpaperSearch';
import { withTranslation } from 'react-i18next';
import Banner from '../components/parts/Banner';
import Helmet from 'react-helmet';

interface IState {
    query: string
}

class Search extends React.Component<any, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            query: this.props.match.params.query
        };
    }

    componentWillReceiveProps(nextProps: any) {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "auto"
        });

        this.setState({
            query: nextProps.match.params.query
        }, this.componentDidMount);
    }

    async componentDidMount() {

    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                <Helmet>
                    <title>{t("Поиск") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container v-index">
                    <div className="wrapper" style={{ paddingBottom: "20px", paddingTop: "20px" }}>
                        <div className="films">
                            <h3>{t("Поиск")}: {t("ключевое слово")}: {this.state.query}</h3>
                        </div>

                        <div className="films">
                            <h4>{t("Фильмы")}</h4>
                        </div>
                        <FilmSearch query={this.state.query} />
                        <hr />
                        <div className="films">
                            <h4>{t("Сериалы")}</h4>
                        </div>
                        <SerialSearch query={this.state.query} />
                        <hr />
                        <Banner className="banner235" place={32} />
                        <hr />

                        <div className="films">
                            <h4>{t("Клипы")}</h4>
                        </div>
                        <ClipSearch query={this.state.query} />
                        <hr />

                        <div className="films">
                            <h4>{t("Альбомы")}</h4>
                        </div>
                        <AlbumSearch query={this.state.query} />
                        <hr />
                        <Banner className="banner235" place={33} />
                        <hr />
                        <div className="films">
                            <h4>{t("Треки")}</h4>
                        </div>
                        <TrackSearch query={this.state.query} />
                        <hr />

                        <div className="films">
                            <h4>{t("Концерты и фестивалы")}</h4>
                        </div>
                        <ConcertSearch query={this.state.query} />
                        <hr />

                        <div className="films">
                            <h4>{t("Новости")}</h4>
                        </div>
                        <ShowBusinessSearch query={this.state.query} />
                        <hr />

                        <div className="films">
                            <h4>{t("Обои")}</h4>
                        </div>
                        <WallpaperSearch query={this.state.query} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Search);